export const parseSettingsModelFromResponse = (response: Object) => {
  response.PreDefinedIps = {
    Enabled: response.IsPredefinedIPsEnabled,
    Delay: response.PredefinedIPsDelay,
    Limit: response.PredefinedIPsLimit
  };
  delete response.Id;
  delete response.IsPredefinedIPsEnabled;
  delete response.PredefinedIPsLimit;
  delete response.PredefinedIPsDelay;
  return response;
};

export const parseSettingsChangeHistoryModelFromResponse = (response: Object) => {
  const { Data: { Models, TotalCount } } = response;
  return {
    data: Models,
    totalCount: TotalCount
  };
};
